import axios, { AxiosError, InternalAxiosRequestConfig } from 'axios';
import { useAuthStore } from '../store/authStore';
import toast from 'react-hot-toast';
import { API_URL } from '../config/api';

export const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor - add auth token
api.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    const token = useAuthStore.getState().token;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error: AxiosError) => {
    return Promise.reject(error);
  }
);

// Response interceptor - handle errors
api.interceptors.response.use(
  (response) => response,
  (error: AxiosError<{ error: string; message?: string }>) => {
    if (error.response) {
      const { status, data } = error.response;

      // Handle specific error codes
      if (status === 401) {
        useAuthStore.getState().logout();
        toast.error('Sesión expirada. Por favor inicia sesión nuevamente.');
      } else if (status === 403) {
        toast.error('No tienes permisos para realizar esta acción.');
      } else if (status === 404) {
        toast.error('Recurso no encontrado.');
      } else if (status >= 500) {
        toast.error('Error del servidor. Por favor intenta más tarde.');
      } else {
        toast.error(data.error || data.message || 'Ha ocurrido un error.');
      }
    } else if (error.request) {
      toast.error('No se pudo conectar con el servidor.');
    } else {
      toast.error('Error al procesar la solicitud.');
    }

    return Promise.reject(error);
  }
);

export default api;
